import { Mail, Quote } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { headerImageStyle } from "../lib/headerImages";
import { PublicPageSkeleton } from "../components/LoadingSkeleton";

export function ClubPage() {
  const { content, loading } = useContent();
  const paragraphs = content.chronicle.body.split(/\n\s*\n/);
  if (loading) return <PublicPageSkeleton variant="standard" />;
  return (
    <>
      <section className="page-hero page-hero--club" style={headerImageStyle(content.headers.club)}><div className="page-width"><span className="eyebrow eyebrow--light"><span /> Seit 1964 in Rehlingen</span><h1>Unser Verein</h1><p>Sportliche Heimat, gewachsene Tradition und ein starkes Miteinander.</p></div></section>
      <section className="section page-width story-grid">
        <div className="story-title"><span className="eyebrow"><span /> Chronik</span><h2>{content.chronicle.title}</h2><p>{content.chronicle.intro}</p><div className="year-mark">1964<small>Gründungsjahr</small></div></div>
        <div className="story-copy">{paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}</div>
      </section>
      <section className="quote-section"><div className="page-width"><Quote /><blockquote>„Nicht nur der Punktgewinn zählt – sondern die Menschen, mit denen wir an der Platte stehen.“</blockquote><span>TTC Rehlingen</span></div></section>
      <section className="section page-width">
        <div className="section-heading split-heading"><div><span className="eyebrow"><span /> Verantwortung im Verein</span><h2>{content.board.title}</h2></div><p>{content.board.intro}</p></div>
        <div className="board-grid">{content.board.members.map((member, index) => (
          <article key={`${member.name}-${index}`}>
            <div className="board-card-top">
              <span className="member-avatar">{member.name.split(" ").map((part) => part[0]).slice(0, 2).join("")}</span>
              <span className="board-card-number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
            </div>
            <div className="board-card-copy">
              <p>{member.role}</p>
              <h3>{member.name}</h3>
              {member.email && <a href={`mailto:${member.email}`}><span><Mail size={16} /></span><em>{member.email}</em></a>}
            </div>
          </article>
        ))}</div>
      </section>
    </>
  );
}
